import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRole } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { MessageEmailErrorResponse, MessageEmailRequest, MessageEmailSuccessResponse } from './messageEmail.types'

export const messageEmailApi = async (request: MessageEmailRequest): Promise<MessageEmailSuccessResponse> => {
  const response = await configureRequest({
    url: urls.notifications.messageEmail,
    method: 'POST',
    data: request,
    params: {},
    headers: {
      'X-User-Role': getUserRole() || ''
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as MessageEmailSuccessResponse
  } else {
    throw response as MessageEmailErrorResponse
  }
}

export default messageEmailApi
